export interface ProjectFileKey {
    id: number
    keyName: string
    maxLen: number
    comment: string
    documentLink: string
    blocked: boolean
}

export function createProjectFileKey(): ProjectFileKey {
    return {
        id: 0,
        keyName: '',
        maxLen: 0,
        comment: '',
        documentLink: '',
        blocked: false
    }
}
